import { FormattedMessage } from "react-intl";
import {
  EcgReviewState,
  IAction,
  Interpretation,
} from "../../../../models/ecg.interface";
import DateTime from "../../../Shared/DateTime/DateTime";
import InterpretationIcon from "../../../Shared/InterpretationIcon/InterpretationIcon";
import EcgAction from "../../EcgEdit/Actions/EcgAction/EcgAction";
import MetaCard from "../MetaCard/MetaCard";
import { useAuthContext } from "../../../../context/AuthContext";
import Role from "../../../../models/role";
import TextDirAligner from "../../../Shared/TextDirAligner/TextDirAligner";

const MetaInterpretationDate = ({
  date,
  user,
}: {
  date?: string;
  user?: string;
}) => (
  <div className="d-flex align-items-center mt-2">
    <InterpretationIcon selected />
    <span className="mx-sm"></span>
    <p className="mb-0 muted-color d-flex">
      <DateTime showTime>{date}</DateTime>
      <span className="mx-sm"></span>
      <TextDirAligner variant="span">{user}</TextDirAligner>
    </p>
  </div>
);

const MetaInterpretationActions = ({ actions }: { actions?: IAction[] }) => {
  return (
    <>
      {actions?.map((action: IAction, index) => (
        <div className="mt-2" key={`${index}_${action.key}`}>
          <EcgAction
            severity={action.severity}
            displayName={action.displayName}
            colorFont
          />
        </div>
      ))}
    </>
  );
};

type MetaInterpretationsProps = {
  interpretation?: Interpretation;
  actions?: IAction[];
  compare?: boolean;
  ecgReviewState?: EcgReviewState;
};

const MetaInterpretations = ({
  interpretation,
  actions,
  compare,
  ecgReviewState,
}: MetaInterpretationsProps) => {
  const {
    state: { user },
  } = useAuthContext();
  const filteredActions = actions?.filter((f) => !!f.value);
  const isInProcessIndication =
    ecgReviewState &&
    ecgReviewState === EcgReviewState.ECRReviewInProcess &&
    user &&
    user.role !== Role.Reviewer;

  return (
    <MetaCard compare={compare}>
      <div className="font-md">
        <p className="mb-0 prim-color-dark font-weight-bold">
          <FormattedMessage
            id="ECG_DETAILS.INTERPRETATION"
            defaultMessage="Interpretation"
          />
        </p>
        {!interpretation?.text && isInProcessIndication ? (
          <p className="mt-2 mb-0">Interpetation is in process...</p>
        ) : (
          ""
        )}
        {interpretation && interpretation.text ? (
          <>
            <TextDirAligner className="mt-2 mb-0">
              {interpretation.text}
            </TextDirAligner>
            <MetaInterpretationActions actions={filteredActions} />
            {!compare && (
              <MetaInterpretationDate
                date={interpretation.date}
                user={interpretation.user.display}
              />
            )}
          </>
        ) : (
          <MetaInterpretationActions actions={filteredActions} />
        )}
      </div>
    </MetaCard>
  );
};

export default MetaInterpretations;
